type LogLevel = "INFO" | "WARN" | "ERROR";
type RequestKind = "INBOUND" | "INTERNAL_API" | "THIRD_PARTY_API";

const LOGGING_ENABLED = process.env.NEXT_PUBLIC_ENABLE_REQUEST_LOGS === "true";

const BACKEND_HOST = (() => {
  try {
    return new URL(process.env.NEXT_PUBLIC_BACKEND_URL ?? "").hostname;
  } catch {
    return "";
  }
})();

export function classifyUrl(url: string): RequestKind {
  if (!url) return "INTERNAL_API";
  try {
    // Relative URLs (e.g. "products/?limit=12") are always internal backend calls
    if (!url.startsWith("http")) return "INTERNAL_API";
    const { hostname } = new URL(url);
    if (hostname === BACKEND_HOST) return "INTERNAL_API";
    return "THIRD_PARTY_API";
  } catch {
    return "INTERNAL_API";
  }
}

function pad(n: number) {
  return String(n).padStart(3, " ");
}

export function logInbound(method: string, path: string) {
  if (!LOGGING_ENABLED) return;
  console.log(`[INBOUND]  ${method.toUpperCase().padEnd(6)} ${path}`);
}

export function logApiRequest(kind: RequestKind, method: string, url: string) {
  if (!LOGGING_ENABLED) return;
  const tag = kind === "THIRD_PARTY_API" ? "[3RD-PARTY]" : "[API]     ";
  console.log(`${tag} → ${method.toUpperCase().padEnd(6)} ${url}`);
}

export function logApiResponse(
  kind: RequestKind,
  method: string,
  url: string,
  status: number,
  statusText: string
) {
  if (!LOGGING_ENABLED) return;
  const level: LogLevel = status >= 500 ? "ERROR" : status >= 400 ? "WARN" : "INFO";
  const tag = kind === "THIRD_PARTY_API" ? "[3RD-PARTY]" : "[API]     ";
  const label = `${pad(status)} ${statusText}`;
  console[level === "INFO" ? "log" : level === "WARN" ? "warn" : "error"](
    `${tag} ← ${method.toUpperCase().padEnd(6)} ${url} — ${label}`
  );
}

export function logApiError(
  kind: RequestKind,
  method: string,
  url: string,
  status: number | undefined,
  message: string
) {
  if (!LOGGING_ENABLED) return;
  const tag = kind === "THIRD_PARTY_API" ? "[3RD-PARTY]" : "[API]     ";
  const label = status ? `${pad(status)} ${message}` : message;
  console.error(`${tag} ✗ ${method.toUpperCase().padEnd(6)} ${url} — ${label}`);
}
